@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../constants/spacing.module.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.edit-data-container {
  border: 1px solid var(--grey-300);
  background-color: var(--white);
  border-radius: 4px;
}

.divider {
  margin-top: @space-8;
  border-color: var(--gray-DFE4E8);
}

.edit-row-container {
  margin: @space-16 @space-16 @space-16;

  .edit-row-header {
    padding-bottom: @space-8;
  }
}

.supplier-container {
  margin-bottom: @space-0;
}

.edit-row {
  gap: @space-32;
}

.column {
  flex: 1;
}

.column-3 {
  flex: 1;
  margin-right: @space-16;

  &:last-child {
    margin-right: @space-0;
  }
}

.one-column {
  width: calc(50% - 16px);
}

.add-edit-supplier-button {
  display: flex;
  align-items: center;
  padding: @space-8 @space-0;
  height: auto;
  color: var(--blue-600, #006fbb);

  button {
    display: flex;
    align-items: center;
  }

  .add-edit-supplier-icon {
    width: 12px;
    display: flex;
    align-items: center;
    margin-right: @space-8;
  }
}

.label-text {
  margin-top: @space-8;
}

.dropdown-field {
  min-height: 40px;
  width: 100%;
  margin-bottom: 0;
}

.label-text-for-warehouse {
  margin-top: 0;
  margin-bottom: @space-4;
  font-size: 14px;
}

.date-picker {
  display: flex;
  height: 32px;
  width: 100%;
  background-color: var(--white);
  input {
    height: 32px;
    border: 1px solid var(--grey-500);
    border-right: none;
  }
  button {
    height: 32px;
    border: 1px solid var(--grey-500);
    display: flex;
  }

  .date-picker-button {
    border: none;
    font-weight: 400;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: @space-0 @space-8;
  }
}

.supplier-buttons {
  display: flex;
  justify-content: space-between;
}

.shipping-details-wrapper {
  margin: @space-0 @space-16;
  border-color: var(--grey-300);
}

.expandable-header-container {
  padding: @space-8 @space-0 !important;
}

.expandable-content-container {
  padding: 0 0 @space-16 !important;
}

.currency-field {
  height: 35px;
}
